
import { USERROLES, FBI_PERMISSIONS } from "../app.config";

export const MenusResponse = {

  'leftTopNavigation': [
    {
      'name': 'Navigation - Main - My Territory',
      'link': '/my-territory',
      'labelMobile': 'LEFT_NAV.MYTERRITORY_NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.MYTERRITORY_NAV_LABEL',
      'hover': 'LEFT_NAV.MYTERRITORY_NAV_LABEL',
      'breadcrumb': 'My Territory',
      'text': 'LEFT_NAV.MYTERRITORY_NAV_LABEL',
      'icon': 'menu-territory-view-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.MTV_ACCESS]
    },
    {
      'name': 'Navigation - Main - Dashboards',
      'link': '/sites',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.MAIN_NAV_LABEL',
      'hover': '',
      'breadcrumb': 'Dashboards',
      'icon': 'menu-dashboard-icon',
      'isSelected': false,
      'text': 'LEFT_NAV.MAIN_NAV_LABEL',
      'subNavigation': [
        {
          'name': 'Navigation - Main - CIP',
          'link': '',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'Ecolab<sup>&reg</sup> CIP IQ&trade;',
          'label': 'Ecolab<sup>&reg</sup> CIP IQ&trade;',
          'hover': 'Ecolab<sup>&reg</sup> CIP IQ&trade;',
          'isExternal': 'true',
          'breadcrumb': 'Ecolab<sup>&reg</sup> CIP IQ&trade;',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': ['025439cf-081c-495c-b40d-f668dbd4bdf0']
        },
        {
          'name': 'Navigation - Main - Inventory',
          'link': '/inventory',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_INVENTORY.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_INVENTORY.NAV_LABEL',
          'hover': 'Inventory',
          'breadcrumb': 'Inventory',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_INVENTORY.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.INVENTORY]
        },
        {
          'name': 'Navigation - Main - Ecolab® Utility Sense IQ™',
          'link': '/utility-sense-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_CLIMATE.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_CLIMATE.NAV_LABEL',
          'hover': 'Ecolab® Utility Sense IQ™',
          'breadcrumb': 'Ecolab® Utility Sense IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_CLIMATE.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.CLIMATE_INTELLIGENCE]
        },
        {
          'name': 'Navigation - Main - eCommerce',
          'link': '',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_ECOMMERCE.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_ECOMMERCE.NAV_LABEL',
          'hover': 'eCommerce',
          'isExternal': 'true',
          'breadcrumb': 'eCommerce',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Navigation - Main - Feed Flex',
          'link': '/feed-flex-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Feed Flex IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Feed Flex IQ™</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> Feed Flex IQ™</span>',
          'breadcrumb': '<span>Ecolab<sup>&reg</sup> Feed Flex IQ™</span>',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': '<span>Ecolab<sup>&reg</sup> Feed Flex IQ™</span>',
          'subNavigation': [],
          'role': [USERROLES.FEED_FLEX]
        },
        {
          'name': 'Navigation - Main - FSQS',
          'link': '/food-safety-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_FSQS.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_FSQS.NAV_LABEL',
          'hover': 'FSQS',
          'breadcrumb': 'FSQS',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_FSQS.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.FSQS_SANITATION_SERVICE_DASHBOARD, USERROLES.FSQS_EMPSERVICE_DASHBOARD]
        },
        {
          'name': 'Navigation - Main - Food and Beverage Intelligence',
          'link': 'fnbIntelligenceUrl',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Food and Beverage Intelligence</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Food and Beverage Intelligence</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> Food and Beverage Intelligence</span>',
          'isExternal': 'true',
          'breadcrumb': 'Food and Beverage Intelligence',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [FBI_PERMISSIONS.FBIDashboard]
        },
        {
          'name': 'Navigation - Main - Water Intelligence',
          'link': 'waterIntelligenceUrl',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Intelligence</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Intelligence</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> Water Intelligence</span>',
          'isExternal': 'true',
          'breadcrumb': 'Water Intelligence',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': ['50011775-a919-45fd-bcea-5f079ce0033e']
        },
        {
          'name': 'Navigation - Main - CondenserIQ',
          'link': '/condenseriq',
          'isGOV': true,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> CondenserIQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> CondenserIQ™</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> CondenserIQ™</span>',
          'breadcrumb': '<span>Ecolab<sup>&reg</sup> CondenserIQ™</span>',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Heat Exchanger IQ',
          'link': '/heat-exchanger-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Heat Exchanger IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Heat Exchanger IQ™</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> Heat Exchanger IQ™</span>',
          'breadcrumb': '<span>Ecolab<sup>&reg</sup> Heat Exchanger IQ™</span>',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Rolling Mills IQ',
          'link': '/rolling-mills-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_ROLLING_MILLS.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_ROLLING_MILLS.NAV_LABEL',
          'hover': 'Ecolab® Rolling Mills IQ™',
          'breadcrumb': 'Ecolab® Rolling Mills IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Caster Systems',
          'link': '/caster-systems-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_CASTER_SYSTEMS.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_CASTER_SYSTEMS.NAV_LABEL',
          'hover': 'Ecolab® Caster Systems IQ™',
          'breadcrumb': 'Ecolab® Caster Systems IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Air Separation IQ',
          'link': '/air-separation-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Air Separation IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Air Separation IQ™</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> Air Separation IQ™</span>',
          'breadcrumb': '<span>Ecolab<sup>&reg</sup> Air Separation IQ™</span>',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - ChillerIQ',
          'link': '/chiller-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> ChillerIQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> ChillerIQ™</span>',
          'hover': '<span>Ecolab<sup>&reg</sup> ChillerIQ™</span>',
          'breadcrumb': '<span>Ecolab<sup>&reg</sup> ChillerIQ™</span>',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.CHILLER_IQ_ADMIN, USERROLES.CHILLER_IQ_DASHBOARD]
        },
        {
          'name': 'Navigation - Main - Recycle Intelligence',
          'link': '/recycle-intelligence',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_RECYCLE.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_RECYCLE.NAV_LABEL',
          'hover': 'Recycle Intelligence',
          'breadcrumb': 'Recycle Intelligence',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_RECYCLE.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.RECYCLE_INTELLIGENCE]
        },
        {
          'name': 'Navigation - Main - RO Optimizer',
          'link': '/ro-optimizer',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_RO_OPTIMIZER.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_RO_OPTIMIZER.NAV_LABEL',
          'hover': 'RO Optimizer',
          'breadcrumb': 'RO Optimizer',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.RODASHBOARD]
        },
        {
          'name': 'Navigation - Main - Scale Guard Index',
          'link': '/scale-guard-index',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_SCALE_GUARD_INDEX.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_SCALE_GUARD_INDEX.NAV_LABEL',
          'hover': 'Scale Guard Index',
          'breadcrumb': 'Scale Guard Index',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.SGI_ADMIN_ACCESS, USERROLES.SGI_READ_ACCESS]
        },
        {
          'name': 'Navigation - Main - Wash Process Intelligence',
          'link': '',
          'isGOV': false,  // Added for GOV Instances
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.WASH_PROCESS_INTELLIGENCE',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.WASH_PROCESS_INTELLIGENCE',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.WASH_PROCESS_INTELLIGENCE',
          'breadcrumb': 'Wash Process Intelligence',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': ['50cc493b-4c55-42f3-a5dc-959764d4fc7b']
        },
        {
          'name': 'Navigation - Main - Water Balance Intelligence',
          'link': '/water-balance-intelligence',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_WATER_BALANCE_INTELLIGENCE.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_WATER_BALANCE_INTELLIGENCE.NAV_LABEL',
          'hover': 'Water Balance Intelligence',
          'breadcrumb': 'Water Balance Intelligence',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WBI_READ_ACCESS]
        },
        {
          'name': 'Navigation - Main - Ecolab® Water Track IQ™',
          'link': '/water-track-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Track IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Track IQ™</span>',
          'hover': 'Ecolab® Water Track IQ™',
          'breadcrumb': 'Ecolab® Water Track IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WFIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Ecolab® Water Quality IQ™ ',
          'link': '/water-quality-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
          'hover': ' Ecolab® Water Quality IQ™ ',
          'breadcrumb': 'Ecolab® Water Quality IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WQDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Ecolab® Water Safety IQ™',
          'link': '/water-safety-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™ </span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™ </span>',
          'hover': 'Ecolab® Water Safety IQ™',
          'breadcrumb': 'Ecolab® Water Safety IQ™',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WSIDASHBOARD]
        },
        {
          'name': 'Navigation - Main - Quadexx Pro',
          'link': 'Quadexx_Pro',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_QUADEXX.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_QUADEXX.NAV_LABEL',
          'hover': 'Quadexx Pro',
          'isExternal': 'true',
          'breadcrumb': 'Quadexx Pro',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': ['0c89d017-913b-4876-994f-749667832f15']
        },
        {
          'name': 'Navigation - Main - Insights',
          'link': 'Insights',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_INSIGHTS.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_INSIGHTS.NAV_LABEL',
          'hover': 'Insights',
          'isExternal': 'true',
          'breadcrumb': 'Insights',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': ['985ee3e3-b5a2-45a1-a36c-a1508150fa31']
        },
        {
          'name': 'Navigation - Main -  Ecolab® Operational Reliability IQ™',
          'link': '/operational-reliability-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_TOTAL_BOOTH_MANAGEMENT.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_TOTAL_BOOTH_MANAGEMENT.NAV_LABEL',
          'hover': ' Ecolab® Operational Reliability IQ™',
          'breadcrumb': ' Ecolab® Operational Reliability IQ™',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_TOTAL_BOOTH_MANAGEMENT.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.TOTAL_BOOTH_MANAGEMENT]
        },
        {
          'name': 'Navigation - Main - Ecolab water for climate',
          'link': '/water-for-climate',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_WATER_FOR_CLIMATE.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_WATER_FOR_CLIMATE.NAV_LABEL',
          'hover': 'Ecolab water for climate',
          'breadcrumb': 'Ecolab water for climate',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_WATER_FOR_CLIMATE.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.WATER_FOR_CLIMATE]
        },
        {
          'name': 'Navigation - Main - Twin IQ',
          'link': '/thermotwin-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_TWINIQ.NAV_NAME',
          'label': 'LEFT_NAV.SUBNAV_TWINIQ.NAV_NAME',
          'hover': 'LEFT_NAV.SUBNAV_TWINIQ.NAV_NAME',
          'breadcrumb': 'LEFT_NAV.SUBNAV_TWINIQ.NAV_NAME',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_TWINIQ.NAV_NAME',
          'subNavigation': [],
          'role': [USERROLES.THERMO_TWIN_IQ] //TBD
        },
        {
          'name': 'Navigation - Main - Utility Sense IQ',
          'link': '/utility-sense-iq',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'LEFT_NAV.SUBNAV_UTILITY_SENSE_IQ.NAV_NAME',
          'label': 'LEFT_NAV.SUBNAV_UTILITY_SENSE_IQ.NAV_NAME',
          'hover': 'LEFT_NAV.SUBNAV_UTILITY_SENSE_IQ.NAV_NAME',
          'breadcrumb': 'LEFT_NAV.SUBNAV_UTILITY_SENSE_IQ.NAV_NAME',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_UTILITY_SENSE_IQ.NAV_NAME',
          'subNavigation': [],
          'role': ['78'] //TBD
        },
        {
          'name': 'Navigation - Main - Pulp & Paper Intelligence',
          'link': '/pulp-&-paper-intelligence',
          'isGOV': false,  // Added for GOV Instances
          'labelMobile': 'Pulp & Paper Intelligence',
          'label': 'Pulp & Paper Intelligence',
          'hover': 'Pulp & Paper Intelligence',
          'breadcrumb': 'Pulp & Paper Intelligence',
          'icon': 'icon-icon_admin',
          'text': 'Pulp & Paper Intelligence',
          'subNavigation': [],
          'role': [USERROLES.PAPER]
        },
        {
          'name': 'Legionella Test Results',
          'link': '/legionella-test-results',
          'labelMobile': '<span>Legionella Test Results</span>',
          'label': '<span>Legionella Test Results</span>',
          'hover': 'Legionella Test Results',
          'breadcrumb': 'Legionella Test Results',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_TEST_RESULTS_DASHBOARD]
        },
        {
          'name': 'Navigation - Main - Coolant Health IQ ',
          'link': '/coolant-health-iq',
          'isGOV': false,
          'labelMobile': '<span>Coolant Health IQ</span>',
          'label': '<span>Coolant Health IQ</span>',
          'hover': ' Coolant Health IQ ',
          'breadcrumb': 'Coolant Health IQ',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.COOLANT_HEALTH_IQ]
        }
      ]
    },
  ],
  'leftMidNavigation': [
    {
      'name': 'Navigation - Main - Service Summary',
      'link': '/service-summary',
      'labelMobile': 'LEFT_NAV.SUBNAV_SERVICE_SUMMARY.NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.SUBNAV_SERVICE_SUMMARY.NAV_LABEL',
      'hover': 'LEFT_NAV.SUBNAV_SERVICE_SUMMARY.NAV_LABEL',
      'breadcrumb': 'Service Summary',
      'text': 'LEFT_NAV.SUBNAV_SERVICE_SUMMARY.NAV_LABEL_MOBILE',
      'icon': 'menu-service-summary-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.ENVISION4WEB]
    },
    {
      'name': 'Navigation - Main - Data Visualization',
      'link': '/data-visualization',
      'labelMobile': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL',
      'hover': 'Data Visualization',
      'text': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL',
      'breadcrumb': 'Data Visualization',
      'icon': 'menu-dv-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.VISDASHBOARD]
    },
    {
      'name': 'Navigation - Main - Financial Impact',
      'link': '/financial-impact',
      'labelMobile': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL',
      'hover': 'Financial Impact',
      'text': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL',
      'breadcrumb': 'Financial Impact',
      'icon': 'menu-financial-impact-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.FIDASHBOARD]
    },
    {
      'name': 'Navigation - Main - Action Log',
      'link': '/action-recommendations',
      'labelMobile': 'ACTION_LOG.HEADER.ACTION_LOG_REC',
      'label': 'ACTION_LOG.HEADER.ACTION_LOG_REC',
      'hover': 'ACTION_LOG.HEADER.ACTION_LOG_REC',
      'breadcrumb': 'Actions Log',
      'text': 'ACTION_LOG.HEADER.ACTION_LOG_REC',
      'icon': 'menu-actionRecommendations-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.ENVISION4WEB]
    },
    {
      'name': 'Navigation - Main - Asset Details ',
      'link': '/asset-details',
      'labelMobile': 'LEFT_NAV.SUBNAV_ASSET_DETAILS.NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.SUBNAV_ASSET_DETAILS.NAV_LABEL',
      'hover': 'asset-details ',
      'breadcrumb': 'asset-details',
      'text': 'LEFT_NAV.SUBNAV_ASSET_DETAILS.NAV_LABEL',
      'icon': 'menu-asset-details-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.ENVISION4WEB]
    },
    {
      'name': 'Navigation - Main - My Documents',
      'link': '/my-documents',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS_MOBILE',
      'label': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
      'hover': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
      'breadcrumb': 'My Documents',
      'text': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
      'icon': 'menu-myDocuments-icon',
      'isSelected': false,
      'subNavigation': [],
      'role': [USERROLES.ENVISION4WEB]
    },
    {
      'name': 'Navigation - Main - Tools',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'label': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'hover': '',
      'breadcrumb': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'text': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'icon': 'menu-tools-icon',
      'isSelected': false,
      'subNavigation': [
        // Alarm And user mangement  should be at first 
        {
          'name': 'Alarm & User Management',
          'link': '/alarm-user-mgmt',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.ALARM_AND_USER_MGMT',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.ALARM_AND_USER_MGMT',
          'hover': 'Alarms',
          'breadcrumb': 'Alarms',
          'icon': 'icon-icon_admin',
          'text': 'LEFT_NAV.SUBNAV_ENVISION.ALARM_AND_USER_MGMT',
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Navigation - Main - Asset Harvester',
          'link': '/assetharvester/siteOverview',
          'labelMobile': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL',
          'hover': 'Asset Harvester',
          'breadcrumb': 'Asset Harvester',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.ASSETHARVESTERREAD, USERROLES.ASSETHARVESTERREADWRITE]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Asset Tree',
          'link': '/asset-tree',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_ASSET_TREE.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_ASSET_TREE.ADMIN_NAV_LABEL',
          'hover': 'Asset Tree',
          'breadcrumb': 'Asset Tree',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ASSETTREEADMIN, USERROLES.ASSETTREEVIEW]
        },
        {
          'name': 'Envision-Configurator-CanningAndBottling',
          'link': 'Configurators_CanningAndBottling',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_CANNING_AND_BOTTLING',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_CANNING_AND_BOTTLING',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_CANNING_AND_BOTTLING',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_CANNING_AND_BOTTLING',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Envision-Configurator',
          'link': 'Envision_Configurator',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATOR',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATOR',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATOR',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATOR',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['-21202bd8-c6f8-49a5-af99-b4dc27b5bf45', USERROLES.ENVISION4WEB]
        },

        {
          'name': 'Envision-Configurator-CoolingWater',
          'link': 'Configurators_CoolingWater',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_COOLING_WATER',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_COOLING_WATER',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_COOLING_WATER',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_COOLING_WATER',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Controller Admin',
          'link': '/equipment-hub',
          'labelMobile': 'EQUIPMENT_HUB.EQUIPMENT_HUB',
          'label': 'EQUIPMENT_HUB.EQUIPMENT_HUB',
          'hover': 'Equipment Hub',
          'breadcrumb': 'Equipment Hub',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ASSETHARVESTERREADWRITE, USERROLES.ENVISIONSALES]
        },
        {
          'name': 'Navigation - Main - Credential Management',
          'link': '/credential-management',
          'labelMobile': 'LEFT_NAV.SUBNAV_CREDENTIAL_MANAGEMENT.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_CREDENTIAL_MANAGEMENT.NAV_LABEL',
          'hover': 'Credential Management',
          'breadcrumb': 'Credential Management',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.CREDMGMT]
        },
        {
          'name': 'Envision-CustomerData-Upload',
          'link': 'Envision_CustomerDataUpload',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CUSTOMER_DATA_UPLOAD',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CUSTOMER_DATA_UPLOAD',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CUSTOMER_DATA_UPLOAD',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CUSTOMER_DATA_UPLOAD',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Navigation - Main - Connectivity',
          'link': '/connectivity',
          'labelMobile': 'LEFT_NAV.SUBNAV_CONNECTIVITY.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_CONNECTIVITY.NAV_LABEL',
          'hover': 'LEFT_NAV.SUBNAV_CONNECTIVITY.NAV_LABEL',
          'breadcrumb': 'Connectivity',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_CONNECTIVITY.NAV_LABEL_MOBILE',
          'subNavigation': [],
          'role': [USERROLES.IOTCWP]
        },
        {
          'name': 'Navigation - Main - Device Certificate Generator',
          'link': '/certificate-generate',
          'labelMobile': 'Device Certificate Generator',
          'label': 'Device Certificate Generator',
          'hover': 'Device Certificate Generator',
          'breadcrumb': 'Device Certificate Generator',
          'icon': 'icon-icon_admin',
          'text': 'Device Certificate Generator',
          'subNavigation': [],
          'role': [USERROLES.CERTGEN_DEVICE_CREATE]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Ecolab Equipment Assets',
          'link': '/equipment-manager',
          'labelMobile': 'Equipment Manager',
          'label': 'Ecolab Equipment Assets',
          'hover': 'Ecolab Equipment Assets',
          'breadcrumb': 'Ecolab Equipment Assets',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ASSETHARVESTERDECOMMISSIONWRITE]
        },
        {
          'name': 'Navigation - Main - E-data',
          'link': 'Envision_EData_Workaround',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.EDATA',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.EDATA',
          'hover': 'E-data-workaround',
          'breadcrumb': 'E-data-workaround',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Navigation - Main - Alarms',
          'link': '/admin-alarm',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.EDATA_AND_INVENTORY_ALARMS',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.EDATA_AND_INVENTORY_ALARMS',
          'hover': 'Alarms',
          'breadcrumb': 'Alarms',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_ENVISION.EDATA_AND_INVENTORY_ALARMS',
          'subNavigation': [],
          'role': [USERROLES.NOTIFICATIONS_ADMIN_OWN, USERROLES.NOTIFICATIONS_ADMIN_INTERNAL, USERROLES.NOTIFICATIONS_CUSTOMER_FULL, USERROLES.NOTIFICATIONS_ADMIN]
        },
        // {
        //   'name': 'Envision-ERB',
        //   'link': 'Envision_ERB',
        //   'isExternal': 'true',
        //   'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.ERB',
        //   'label': 'LEFT_NAV.SUBNAV_ENVISION.ERB',
        //   'hover': 'LEFT_NAV.SUBNAV_ENVISION.ERB',
        //   'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.ERB',
        //   'icon': 'icon-icon_admin',
        //   'isSelected': false,
        //   'subNavigation': [],
        //   'isVisible': false,
        //   'role': ['-21202bd8-c6f8-49a5-af99-b4dc27b5bf45', USERROLES.ENVISION4WEB]
        // },
        {
          'name': 'Hub',
          'link': 'Desktop_Hub',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_HUB.HUB',
          'label': 'LEFT_NAV.SUBNAV_HUB.HUB',
          'hover': 'LEFT_NAV.SUBNAV_HUB.HUB',
          'breadcrumb': 'LEFT_NAV.SUBNAV_HUB.HUB',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        // Equipment Connectivity menu should be here
        {
          'name': 'Navigation - Main - Admin & Settings - Logo Management',
          'link': '/logo-management',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_SERVICE_SUMMARY.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_SERVICE_SUMMARY.ADMIN_NAV_LABEL',
          'hover': 'Logo Management',
          'breadcrumb': 'Logo Management',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.SSD_LOGO_MANAGEMENT]
        },
        // Controller credential Menu, Plannig for June release.
        {
          'name': 'Navigation - Main - Admin & Settings - Controller Credentials',
          'link': '/controller-credentials',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_CONTROLLER_CREDENTIALS.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_CONTROLLER_CREDENTIALS.ADMIN_NAV_LABEL',
          'hover': 'NextGen Controller credential',
          'breadcrumb': 'NextGen Controller credential',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Envision-Configurator-SecondaryDesinfection',
          'link': 'Configurators_SecondaryDesinfection',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_SECONDARY_DISINFECTION',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_SECONDARY_DISINFECTION',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_SECONDARY_DISINFECTION',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_SECONDARY_DISINFECTION',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Envision-USBManualNextGenUpgrades',
          'link': 'Envision_NextGenUpgrades',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.USB_MANUAL_NEXTGEN_UPGRADES',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.USB_MANUAL_NEXTGEN_UPGRADES',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.USB_MANUAL_NEXTGEN_UPGRADES',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.USB_MANUAL_NEXTGEN_UPGRADES',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Envision-Configurator-WasteWaterOther',
          'link': 'Configurators_WasteWaterOther',
          'isExternal': 'true',
          'labelMobile': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_WASTEWATER_OTHER',
          'label': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_WASTEWATER_OTHER',
          'hover': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_WASTEWATER_OTHER',
          'breadcrumb': 'LEFT_NAV.SUBNAV_ENVISION.CONFIGURATORS_WASTEWATER_OTHER',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'isVisible': false,
          'role': ['21202bd8-c6f8-49a5-af99-b4dc27b5bf45']
        },
        {
          'name': 'Navigation - wfi - Alarms',
          'link': '/water-track-iq-alarm',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Track IQ™ Alarms </span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Track IQ™ Alarms </span>',
          'hover': 'Ecolab® Water Track IQ™ Alarms',
          'breadcrumb': 'Ecolab® Water Track IQ™ Alarms',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': '<span>Ecolab<sup>&reg</sup> Water Track IQ™ Alarms </span>',
          'subNavigation': [],
          'role': [USERROLES.NOTIFICATIONS_ADMIN_OWN, USERROLES.NOTIFICATIONS_ADMIN_INTERNAL, USERROLES.NOTIFICATIONS_CUSTOMER_FULL, USERROLES.NOTIFICATIONS_ADMIN]
        },
        // {
        //   'name': 'Navigation - Main - Admin & Settings - Water Flow Intelligence',
        //   'link': '/water-flow-intelligence/admin/sensor-config',
        //   'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_WFI_SENSOR_CONFIG.ADMIN_NAV_LABEL_MOBILE',
        //   'label': 'LEFT_NAV.ADMIN_SUBNAV_WFI_SENSOR_CONFIG.ADMIN_NAV_LABEL',
        //   'hover': 'WFI Sensor Mapping',
        //   'breadcrumb': 'WFI Sensor Mapping',
        //   'icon': 'icon-icon_admin',
        //   'isSelected': false,
        //   'subNavigation': [],
        //   'role': ['51aff163-bcf2-415a-b468-667299ff8ae9']
        // },
        {
          'name': 'Navigation - Main - Manual Equipment Creation',
          'link': '/manual-equipment-creation',
          'labelMobile': 'Manual Equipment Creation Requestor',
          'label': 'Manual Equipment Creation Requestor',
          'hover': 'Manual Equipment Creation Requestor',
          'breadcrumb': 'Manual Asset Creation Requestor',
          'icon': 'icon-icon_admin',
          'subNavigation': [],
          'role': [USERROLES.HARVESTERMANUALEQUIPMENTREQUESTOR]
        },
        {
          'name': 'Navigation - Main - Manual Equipment Creation',
          'link': '/manual-equipment-creation/approverPage',
          'labelMobile': 'Manual Equipment Creation Approver',
          'label': 'Manual Equipment Creation Approver',
          'hover': 'Manual Equipment Creation Approver',
          'breadcrumb': 'Manual Asset Creation Approver',
          'icon': 'icon-icon_admin',
          'subNavigation': [],
          'role': [USERROLES.HARVESTERMANUALEQUIPMENTAPPROVER]
        },
        {
          'name': 'Upload Reports & Plans',
          'link': '/upload-reports-and-plans',
          'labelMobile': '<span>Upload Reports & Plans</span>',
          'label': '<span>Upload Reports & Plans</span>',
          'hover': 'Upload Reports & Plans',
          'breadcrumb': 'Upload Reports & Plans',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_DASHBOARD_SAMPLE_REPORT_UPLOAD, USERROLES.LEGIONELLA_DASHBOARD_WM_PLAN_UPLOAD]
        }
      ],
      'role': [USERROLES.ENVISION4WEB]
    },
    {
      'name': 'Navigation - Main - Admin & Settings',
      'link': '/settings',
      'labelMobile': 'LEFT_NAV.ADMIN_NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.ADMIN_NAV_LABEL',
      'hover': '',
      'breadcrumb': 'Settings',
      'icon': 'menu-settings-icon',
      'isSelected': false,
      'text': 'LEFT_NAV.ADMIN_NAV_LABEL',
      'subNavigation': [

        {
          'name': 'Navigation - Main - Admin & Settings - Ecolab® Water Safety IQ™',
          'link': '/water-safety-iq/admin',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™ Admin </span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™ Admin </span>',
          'hover': 'Ecolab® Water Safety IQ™ Admin',
          'breadcrumb': 'Ecolab® Water Safety IQ™ Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WSIADMIN]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Quality ',
          'link': '/water-quality-iq/admin',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ Admin</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ Admin</span>',
          'hover': 'Ecolab® Water Quality IQ™ Admin',
          'breadcrumb': 'Ecolab® Water Quality IQ™ Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WQDASHBOARD] // changed from 11
        },
        {
          'name': 'Navigation - Main - Admin & Settings - OMNI ',
          'link': '/omni/admin',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_OMNI.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_OMNI.ADMIN_NAV_LABEL',
          'hover': 'OMNI Admin',
          'breadcrumb': 'OMNI Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIADMIN]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Climate Intelligence ',
          'link': '/utility-sense-iq/admin',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_CLIMATE_INTELLIGENCE.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_CLIMATE_INTELLIGENCE.ADMIN_NAV_LABEL',
          'hover': 'Climate-Intelligence Admin',
          'breadcrumb': 'Climate-Intelligence Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.CLIMATE_INTELLIGENCE_ADMIN]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Ecolab® ThermoTwin IQ™ Admin ',
          'link': '/thermotwin-iq/admin',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> ThermoTwin IQ™ Admin</span>',
          'label': '<span>Ecolab<sup>&reg</sup> ThermoTwin IQ™ Admin</span>',
          'hover': 'Ecolab® ThermoTwin IQ™ Admin',
          'breadcrumb': 'Ecolab® ThermoTwin IQ™ Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.THERMO_TWIN_IQ_ADMIN]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - Notifications',
          'link': '/notifications-admin',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_NOTIFICATIONS.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_NOTIFICATIONS.ADMIN_NAV_LABEL',
          'hover': 'Notifications Admin',
          'breadcrumb': 'Notifications Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.NOTIFICATIONS_ADMIN_OWN, USERROLES.NOTIFICATIONS_ADMIN_INTERNAL, USERROLES.NOTIFICATIONS_CUSTOMER_FULL, USERROLES.NOTIFICATIONS_CUSTOMER_ADD]
        },
        {
          'name': 'Navigation - Main - Admin & Settings - System Assurance Admin',
          'link': '/system-assurance/admin',
          'labelMobile': 'LEFT_NAV.ADMIN_SUBNAV_SYSTEM_ASSURANCE.ADMIN_NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.ADMIN_SUBNAV_SYSTEM_ASSURANCE.ADMIN_NAV_LABEL',
          'hover': 'System Assurance Admin',
          'breadcrumb': 'System Assurance Admin',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.SAADMIN]
        },
        {
          'name': 'Navigation - Main - Recycle Intelligence Configuration',
          'link': '/recycle-intelligence-configuration',
          'labelMobile': 'LEFT_NAV.SUBNAV_RECYCLE_INTELLIGENCE_CONFIGURATION.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_RECYCLE_INTELLIGENCE_CONFIGURATION.NAV_LABEL',
          'hover': 'Recycle Intelligence Configuration',
          'breadcrumb': 'Recycle Intelligence Configuration',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'text': 'LEFT_NAV.SUBNAV_RECYCLE_INTELLIGENCE_CONFIGURATION.NAV_LABEL',
          'subNavigation': [],
          'role': [USERROLES.RECYCLE_INTELLIGENCE_ADMIN]
        }
      ]
    },
  ],

  'leftBottomNavigation': [
    {
      'name': 'Training',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_TRAINING',
      'label': 'LEFT_NAV.MAIN_NAV_TRAINING',
      'hover': '',
      'breadcrumb': 'Training',
      'text': 'LEFT_NAV.MAIN_NAV_TRAINING',
      'icon': 'menu-training-icon',
      'isSelected': false,
      'subNavigation': [
        {
          'name': 'Training Customers',
          'link': 'Training-Customers-External',
          'labelMobile': 'LEFT_NAV.CUSTOMERS',
          'label': 'LEFT_NAV.CUSTOMERS',
          'hover': '',
          'breadcrumb': 'Training Customers',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Training Ecolab Associate',
          'link': 'Training-Ecolab-Associate',
          'labelMobile': 'LEFT_NAV.ECOLAB_ASSOCIATE',
          'label': 'LEFT_NAV.ECOLAB_ASSOCIATE',
          'hover': ' Ecolab Associate ',
          'breadcrumb': 'Ecolab Associate ',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        }
      ]
    },
    // Feedback forums sub navigation links are sorted in ascending order.
    {
      'name': 'Feedback - Uservoice',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
      'label': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
      'hover': '',
      'breadcrumb': 'Feedback - Uservoice',
      'text': 'LEFT_NAV.MAIN_NAV_FEEDBACKFORUMS',
      'icon': 'menu-feedback-icon',
      'isSelected': false,
      'subNavigation': [
        {
          'name': 'Actions & Recommendations',
          'link': 'Action-Recommendation-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_ACTION.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_ACTION.NAV_LABEL',
          'hover': ' Actions & Recommendations',
          'breadcrumb': 'Actions & Recommendations',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Asset Harvester',
          'link': 'Asset-Harvester-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_SITE_SETUP.NAV_LABEL',
          'hover': ' Asset Harvester ',
          'breadcrumb': 'Asset Harvester',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ASSETHARVESTERREAD, USERROLES.ASSETHARVESTERREADWRITE]
        },
        {
          'name': 'Data Visualization',
          'link': 'data-Visualization-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_DATA_VISUALIZATION.NAV_LABEL',
          'hover': 'Data Visualization',
          'breadcrumb': 'Data Visualization',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.VISDASHBOARD]
        },
        {
          'name': 'E-Data',
          'link': 'E-Data-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_E_DATA.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_E_DATA.NAV_LABEL',
          'hover': 'E-Data',
          'breadcrumb': 'E-Data',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'ECHO (Ecolab Communication Hub Operator)',
          'link': 'ECHO-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_ECHO.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_ECHO.NAV_LABEL',
          'hover': 'ECHO (Ecolab Communication Hub Operator)',
          'breadcrumb': 'ECHO (Ecolab Communication Hub Operator)',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Financial Impact',
          'link': 'financial-impact-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_FINANCIAL_IMPACT.NAV_LABEL',
          'hover': 'Financial Impact',
          'breadcrumb': 'Financial Impact',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.FIDASHBOARD, USERROLES.FIADMIN]
        },
        {
          'name': 'Inventory Management',
          'link': 'Inventory-Management-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_INVENTORY_MANAGEMENT.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_INVENTORY_MANAGEMENT.NAV_LABEL',
          'hover': 'Inventory Management',
          'breadcrumb': 'Inventory Management',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'My Documents',
          'link': 'my-documents-Uservoice',
          'labelMobile': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS_MOBILE',
          'label': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
          'hover': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
          'breadcrumb': 'My Documents',
          'text': 'LEFT_NAV.MAIN_NAV_MYDOCUMENTS',
          'icon': 'ico-nav-my-documents',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Omni',
          'link': 'Omni-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_OMNI.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_OMNI.NAV_LABEL',
          'hover': ' Omni ',
          'breadcrumb': 'Omni',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.OMNIDASHBOARD]
        },
        {
          'name': 'Service Summary Dashboard',
          'link': 'service-summary-Uservoice',
          'labelMobile': 'LEFT_NAV.SUBNAV_SSD.NAV_LABEL_MOBILE',
          'label': 'LEFT_NAV.SUBNAV_SSD.NAV_LABEL',
          'hover': ' Service Summary Dashboard',
          'breadcrumb': 'Service Summary Dashboard',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Ecolab® Water Track IQ™',
          'link': 'water-track-iq-Uservoice',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Track IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Track IQ™</span>',
          'hover': 'Ecolab® Water Track IQ™',
          'breadcrumb': 'Ecolab® Water Track IQ™',
          'icon': 'icon-icon_admin',
          'subNavigation': [],
          'isSelected': false,
          'role': [USERROLES.WFIDASHBOARD]
        },
        {
          'name': 'Water Quality',
          'link': 'Water-Quality-Uservoice',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Quality IQ™ </span>',
          'hover': ' Ecolab® Water Quality IQ™',
          'breadcrumb': 'Ecolab® Water Quality IQ™',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WQDASHBOARD, USERROLES.WQADMIN]
        },
        {
          'name': 'Ecolab® Water Safety IQ™',
          'link': 'Ecolab-Water-Safety-IQ-Uservoice',
          'labelMobile': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™</span>',
          'label': '<span>Ecolab<sup>&reg</sup> Water Safety IQ™</span>',
          'hover': 'Ecolab® Water Safety IQ™',
          'breadcrumb': 'Ecolab® Water Safety IQ™',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.WSIDASHBOARD, USERROLES.WSIADMIN]
        }
      ]
    },
    {
      'name': 'Support Info',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_SUPPORT_SAFETY_INFO',
      'label': 'LEFT_NAV.MAIN_NAV_SUPPORT_SAFETY_INFO',
      'hover': '',
      'breadcrumb': 'Support Info',
      'text': 'LEFT_NAV.MAIN_NAV_SUPPORT_INFO',
      'icon': 'menu-support-icon',
      'isSelected': false,
      'isVisible': true,
      'subNavigation': [
        {
          'name': 'Ecolab Digital Support:(866) 851 – 8670',
          'link': '',
          'href': 'tel:(866) 851 – 8670',
          'labelMobile': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT',
          'label': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT',
          'hover': '',
          'breadcrumb': 'Ecolab Digital Support:(866) 851 – 8670',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': false,
          'region': ['North America', 'Latinamerica'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Onboarding Support:\n 855-432-6522',
          'link': '',
          'href': 'tel:855-432-6522',
          'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_NA',
          'label': 'LEFT_NAV.ONBOARDING_SUPPORT_NA',
          'hover': '',
          'breadcrumb': 'Onboarding Support:\n 855-432-6522',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['North America'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Onboarding Support:\n +31 71 524 1111',
          'link': '',
          'href': 'tel:+31 71 524 1111',
          'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_EU',
          'label': 'LEFT_NAV.ONBOARDING_SUPPORT_EU',
          'hover': '',
          'breadcrumb': 'Onboarding Support:\n +31 71 524 1111',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['Europe'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Onboarding Support:\n Digital Contacts',
          'link': '',
          'href': '',
          'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA_PACIFIC',
          'label': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA_PACIFIC',
          'hover': '',
          'breadcrumb': 'Onboarding Support: Digital Contacts',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['Pacific', 'Greater China', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],// Should remove other regions except pscific for this menu till we get the confirmation
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Ecolab Digital Support:',
          'link': '',
          'href': '',
          'labelMobile': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT_ALL',
          'label': 'LEFT_NAV.ECOLAB_DIGITAL_SUPPORT_ALL',
          'hover': '',
          'breadcrumb': 'Ecolab Digital Support:',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': false,
          'region': ['Europe', 'Pacific', 'Mid.East/Africa'], // 'Greater China'
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        //Should uncomment it after getting confirmed menu
        // {
        //   'name': 'Onboarding Support: ',
        //   'link': '',
        //   'href': 'tel:',
        //   'labelMobile': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA',
        //   'label': 'LEFT_NAV.ONBOARDING_SUPPORT_IMEA',
        //   'hover': '',
        //   'breadcrumb': 'Onboarding Support:',
        //   'icon': '',
        //   'isSelected': false,
        //   'isVisible': true,
        //   'isInternalUser': true,
        //   'region': ['Greater China', 'Latinamerica', 'Mid.East/Africa'],
        //   'subNavigation': [],
        //   'role': [USERROLES.ENVISION4WEB]
        // },
        {
          'name': 'Email',
          'link': '',
          'href': '',
          'target': '',
          'labelMobile': 'LEFT_NAV.EGIC_EMAIL',
          'label': 'LEFT_NAV.EGIC_EMAIL',
          'hover': 'Email',
          'breadcrumb': 'Email',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Site Action Request',
          'link': 'SITE Creation (Emily Synal) (formsite.com)',
          'href': '',
          'labelMobile': 'LEFT_NAV.SITE_ACTION_REQUEST',
          'label': 'LEFT_NAV.SITE_ACTION_REQUEST',
          'hover': 'Site Action Request',
          'breadcrumb': 'Site Action Request',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa', 'Unknown'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Digital Support Dashboard',
          'link': '',
          'href': 'https://ecolab.sharepoint.com/sites/IndustrialDigitalSupportDashboard/SitePages/ECOLAB3D-noticeboard.aspx?csf=1&&web=1&&e=ZuTHyf&&cid=6ed84063-33a2-4490-8729-b4d391a134ed',
          'labelMobile': 'LEFT_NAV.DIGITAL_SUPPORT_DASHBOARD',
          'label': 'LEFT_NAV.DIGITAL_SUPPORT_DASHBOARD',
          'hover': 'Digital Support Dashboard',
          'breadcrumb': 'Digital Support Dashboard',
          'icon': '',
          'isSelected': false,
          'isVisible': true,
          'isInternalUser': true,
          'region': ['North America', 'Europe', 'Greater China', 'Pacific', 'Latinamerica', 'Mid.East/Africa'],
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Emergency Numbers',
          'link': 'common-pages/emergency-numbers',
          'labelMobile': 'LEFT_NAV.EMERGENCY',
          'label': 'LEFT_NAV.EMERGENCY',
          'hover': '',
          'breadcrumb': 'Emergency Numbers',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'SH&E Reference',
          'link': 'common-pages/safety-health',
          'labelMobile': 'LEFT_NAV.SH&E',
          'label': 'LEFT_NAV.SH&E',
          'hover': 'SH&E Reference',
          'breadcrumb': 'SH&E Reference',
          'icon': '',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISION4WEB]
        },
        {
          'name': 'Access Request',
          'link': 'common-pages/access-request',
          'labelMobile': 'LEFT_NAV.ECOLAB3D_ACCESS_REQUEST_FOR_USERS',
          'label': 'LEFT_NAV.ECOLAB3D_ACCESS_REQUEST_FOR_USERS',
          'hover': 'Access Request',
          'breadcrumb': 'Access Request',
          'icon': '',
          'isInternalUser': true,
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.ENVISIONSALES]
        }
      ]
    }
  ],



};

export const AWSMenusResponseForLeftNav = {
  'leftTopNavigation': [
    {
      'name': 'Navigation - Main - Dashboards',
      'link': '/sites',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.MAIN_NAV_LABEL',
      'hover': '',
      'breadcrumb': 'Dashboards',
      'icon': 'menu-dashboard-icon',
      'isSelected': false,
      'text': 'LEFT_NAV.MAIN_NAV_LABEL',
      'subNavigation': [
        {
          'name': 'Legionella Test Results',
          'link': '/legionella-test-results',
          'labelMobile': '<span>Legionella Test Results</span>',
          'label': '<span>Legionella Test Results</span>',
          'hover': 'Legionella Test Results',
          'breadcrumb': 'Legionella Test Results',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_TEST_RESULTS_DASHBOARD]
        },
        {
          'name': 'Navigation - Main - Coolant Health IQ ',
          'link': '/coolant-health-iq',
          'isGOV': false,
          'labelMobile': '<span>Coolant Health IQ</span>',
          'label': '<span>Coolant Health IQ</span>',
          'hover': ' Coolant Health IQ ',
          'breadcrumb': 'Coolant Health IQ',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.COOLANT_HEALTH_IQ]
        }
      ]
    },
  ],
  'leftMidNavigation': [
    {
      'name': 'Navigation - Main - Tools',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'label': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'hover': '',
      'breadcrumb': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'text': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'icon': 'menu-tools-icon',
      'isSelected': false,
      'subNavigation': [
        {
          'name': 'Upload Reports & Plans',
          'link': '/upload-reports-and-plans',
          'labelMobile': '<span>Upload Reports & Plans</span>',
          'label': '<span>Upload Reports & Plans</span>',
          'hover': 'Upload Reports & Plans',
          'breadcrumb': 'Upload Reports & Plans',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_DASHBOARD_SAMPLE_REPORT_UPLOAD, USERROLES.LEGIONELLA_DASHBOARD_WM_PLAN_UPLOAD]
        }]
    }
  ],
  'leftBottomNavigation': []
}


export const AWSMenusResponse = {
  'leftTopNavigation': [
    {
      'name': 'Navigation - Main - Dashboards',
      'link': '/sites',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_LABEL_MOBILE',
      'label': 'LEFT_NAV.MAIN_NAV_LABEL',
      'hover': '',
      'breadcrumb': 'Dashboards',
      'icon': 'menu-dashboard-icon',
      'isSelected': false,
      'text': 'LEFT_NAV.MAIN_NAV_LABEL',
      'subNavigation': [
        {
          'name': 'Legionella Test Results',
          'link': '/legionella-test-results',
          'labelMobile': '<span>Legionella Test Results</span>',
          'label': '<span>Legionella Test Results</span>',
          'hover': 'Legionella Test Results',
          'breadcrumb': 'Legionella Test Results',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_TEST_RESULTS_DASHBOARD]
        },
        {
          'name': 'Navigation - Main - Coolant Health IQ ',
          'link': '/coolant-health-iq',
          'isGOV': false,
          'labelMobile': '<span>Coolant Health IQ</span>',
          'label': '<span>Coolant Health IQ</span>',
          'hover': ' Coolant Health IQ ',
          'breadcrumb': 'Coolant Health IQ',
          'icon': 'icon-icon_admin',
          'isSelected': false,
          'subNavigation': [],
          'role': [USERROLES.COOLANT_HEALTH_IQ]
        }
      ]
    },
  ],
  'leftMidNavigation': [
    {
      'name': 'Navigation - Main - Tools',
      'link': '',
      'labelMobile': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'label': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'hover': '',
      'breadcrumb': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'text': 'LEFT_NAV.MAIN_NAV_TOOLS',
      'icon': 'menu-tools-icon',
      'isSelected': false,
      'subNavigation': [
        {
          'name': 'Upload Reports & Plans',
          'link': '/upload-reports-and-plans',
          'labelMobile': '<span>Upload Reports & Plans</span>',
          'label': '<span>Upload Reports & Plans</span>',
          'hover': 'Upload Reports & Plans',
          'breadcrumb': 'Upload Reports & Plans',
          'icon': '',
          'isSelected': true,
          'subNavigation': [],
          'role': [USERROLES.LEGIONELLA_DASHBOARD_SAMPLE_REPORT_UPLOAD, USERROLES.LEGIONELLA_DASHBOARD_WM_PLAN_UPLOAD]
        }]
    }
  ],
  'leftBottomNavigation': []
}


